<script>
import VTextarea from 'vuetify/lib/components/VTextarea';

export default {
  mixins: [ VTextarea ],

  props: {
    onEnterKeyDownCallback: { type: Function }
  },

  data() {
    return {
      $_isCompositionStarted: false,
    };
  },

  mounted() {
    this.$refs.input.addEventListener('compositionstart', this.$_onCompositionstart);
    this.$refs.input.addEventListener('compositionend', this.$_onCompositionend);
    this.$refs.input.addEventListener('keydown', this.$_onKeydown);
  },

  beforeDestroy() {
    this.$refs.input.removeEventListener('compositionstart', this.$_onCompositionstart);
    this.$refs.input.removeEventListener('compositionend', this.$_onCompositionend);
    this.$refs.input.removeEventListener('keydown', this.$_onKeydown);
  },

  methods: {
    /* private */
    $_onCompositionstart() {
      this.$data.$_isCompositionStarted = true;
    },

    $_onCompositionend() {
      this.$data.$_isCompositionStarted = false;
    },

    $_onKeydown(event) {
      if (this.$data.$_isCompositionStarted) event.stopPropagation();
    },

    /* override */
    onKeyDown(event) {
      if ((event.code === 'Enter') && (!event.ctrlKey)) event.stopPropagation();
      this.$emit('keydown', event);
    }
  },
}
</script>
